var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('ErrorBox'),_c('router-view',{attrs:{"pathAfterLogin":_vm.pathAfterLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }